export default __webpack_public_path__ + "static/astrorei-cta-3386906d212bb98bc1c9ddfc94356715.jpg";